// extracted by mini-css-extract-plugin
module.exports = {"container":"tabPreview_container__4vBQS","tabTitle":"tabPreview_tabTitle__Mswd1"};